import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { InfoPagesReducer } from './reducer/infosPage'
import {
  CreateJobReducer,
  ListJobsReducer,
  SearchSpecifyJobReducer,
  UpdateJobReducer,
  UploadJobReducer
} from './reducer/job'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

const initialState = {
  infoPages: {
    key: localStorage.getItem('key') ? JSON.parse(localStorage.getItem('key') as string) : ''
  }
}

const reducer = combineReducers({
  listJobs: ListJobsReducer,
  searchSpecifyJob: SearchSpecifyJobReducer,
  createJob: CreateJobReducer,
  updateJob: UpdateJobReducer,
  infoPages: InfoPagesReducer,
  uploadJob: UploadJobReducer
})

export type RootState = ReturnType<typeof reducer>

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, initialState, composeEnhancer(applyMiddleware(thunk)))

export default store
